import React from "react";
import { useTranslation } from "react-i18next";
import { TWebsiteBuilderHandleUpdateState, TWebsiteBuilderHandleDebouncedUpdateState } from "pages/secure/facility/websiteBuilder/editor/hooks/debouncedUpdate/useWebsiteBuilderDebouncedUpdate";
import { IWebsiteBuilderMarqueeIconItem, IWebsiteBuilderMarqueeSettings } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderMarquee";
import { WebsiteBuilderIconSettingsView } from "../../element/icon/IconSettings";

interface IMarqueeSettingsEditIconViewProps {
  item: IWebsiteBuilderMarqueeIconItem;
  handleUpdateState: TWebsiteBuilderHandleUpdateState<IWebsiteBuilderMarqueeSettings>;
  handleDebouncedUpdateState: TWebsiteBuilderHandleDebouncedUpdateState<IWebsiteBuilderMarqueeSettings>;
  onBack: () => void;
  closeSettings: () => void;
}

export function MarqueeSettingsEditIconView(props: IMarqueeSettingsEditIconViewProps) {
  const { item, handleUpdateState, handleDebouncedUpdateState, onBack, closeSettings } = props;

  const { t } = useTranslation();

  return (
    <WebsiteBuilderIconSettingsView
      title={t("Edit icon")}
      settings={item.settings}
      onChange={settings => handleUpdateState(prev => ({
        ...prev,
        items: prev.items.map(prevItem => prevItem.id === item.id && prevItem.type === "icon"
          ? { ...prevItem, settings }
          : prevItem),
      }))}
      onDebouncedChange={settings => handleDebouncedUpdateState(prev => ({
        ...prev,
        items: prev.items.map(prevItem => prevItem.id === item.id && prevItem.type === "icon"
          ? { ...prevItem, settings }
          : prevItem),
      }))}
      onBack={onBack}
      closeSettings={closeSettings}
    />
  );
}
